import { Component, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterOutlet } from '@angular/router';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

import { MemberRemoveComponent } from '../../tools/member-remove/member-remove.component';
import { ConfirmDialogComponent } from '../../tools/confirm-dialog/confirm-dialog.component';
import { EditSubsAdminComponent } from '../../tools/edit-subs-admin/edit-subs-admin.component';
import { ModalCancelSubscriptionComponent } from '../../tools/modal-cancel-subscription/modal-cancel-subscription.component';
import { UsuarioService } from '../../services/usuario.service';
import { FacadeService } from '../../services/facade.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { ProyectosService } from '../../services/proyectos.service';
import { environment } from '../../../environments/environment';

import { ChangeDetectorRef } from '@angular/core';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';

import { ReactiveFormsModule } from '@angular/forms'; // For FormGroup
import { MatNativeDateModule } from '@angular/material/core'; // For native Date adapter

import { OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { MatMenuTrigger } from '@angular/material/menu';

import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { stringify } from 'node:querystring';
import { MatTooltipModule } from '@angular/material/tooltip';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


Chart.register(ChartDataLabels);


interface Project {
  name: string;
  wordCount: string;
  sections: string;
}

interface Error {
  date: string;
  code: string;
  endpoint: string;
  method: string;
}

interface Users {
  id: string;
  user: string;
  email: string;
  typeSubs: string;
  start_d: string;
  end_d: string;
  last_logged_on: string;
  organisation: string;
  extra_permissions: string;
}


@Component({
  selector: 'profile',
  standalone: true,
  imports: [CommonModule,
    RouterOutlet,
    MatTableModule,
    MatDialogModule,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatPaginatorModule,
    FormsModule,
    BaseChartDirective,
    HttpClientModule,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    OverlayModule,
    MatDatepickerModule,
    MatTooltipModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  providers: [DatePipe]
})
export class ProfileComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
  public originalName: string | undefined | null;
  public originalEmail: string | undefined | null;
  public originalPass: string | undefined | null;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActive3: boolean;
  apiUsage_loaderActive: boolean;

  loaderActive_subscribers: boolean;
  loaderActive_organization: boolean;

  loaderActive_export: boolean;

  showChartContainer = true;
  showChartContainer2 = true;

  valueLimitProjects: boolean;
  isRolAdmin: boolean = false;
  isRolLeader: boolean = false;
  users_organization_limit = 10;

  selectedTab: string = 'profile';  // Tab inicial
  selectedButton: boolean = false;
  splitCharacter: string = '';
  isExpanded = false;
  isExpanded2 = true;

  startDate!: Date;
  endDate!: Date;


  showPassword: boolean = false;
  showPassword2: boolean = false;
  showPassword3: boolean = false;

  isEditing_Profile = false;
  public userObject = null;

  public datos_pagina = {
    name: 'Name Last Name',
    email: 'username080808@gmail.com',
    pass: ''
  };


  dateForm: FormGroup;
  DateText = 'Select Date Range'; // Initial button text
  DateText2 = 'Select Date Range'; // Initial button text
  readonly apiTimeZone = 'Europe/London';
  readonly apiTimeZoneLabel = 'London Time';
  readonly subscriptionRedirectUrl = `${environment.text_wp.replace(/\/$/, '')}/wpsubscribe/`;
  private datePipe: DatePipe;

  currentPageProjects = 1;
  paginatedProjects = new MatTableDataSource<Error>();
  pagesProjects: number[] = [];
  api_usage_data: any[] = [];
  displayedColumns_api_usage_users: string[] = ['account_name', 'account_email', 'api_requests', 'api_documents'];
  more_info_api_usage = undefined;

  name_payment_test: string = '';
  payment_start: Date | null = null;
  payment_end: Date | null = null;
  payment_status: string = '';
  payment_ok: number | null = null;
  payment_range_text: string = '';
  constructor(
    public dialog: MatDialog,
    private userService: UsuarioService,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    private cdr: ChangeDetectorRef,
    private datePipeInstance: DatePipe
  ) {
    this.datePipe = datePipeInstance;
    this.dateForm = new FormGroup({
      start: new FormControl(null),
      end: new FormControl(null)
    });
  }

  toggleEdit() {
    this.originalName = this.name;
    this.originalEmail = this.email;
    this.originalPass = this.pass;
    this.isEditing_Profile = true;
    this.confirmPass = this.pass;
  }

  saveValues() {
    if (this.passwordsMatch()) {
      this.userService.update_info(this.http, { name: this.name })
      this.isEditing_Profile = false;
    }
  }

  cancelEdit() {
    this.name = this.originalName;
    this.email = this.originalEmail;
    this.pass = this.originalPass;
    this.confirmPass = this.originalPass;
    this.isEditing_Profile = false;
  }


  public name: string | undefined | null;
  public email: string | undefined | null;
  public pass: string | undefined | null;
  public confirmPass: string | undefined | null;
  public text_UID: string | undefined | null;
  public isAdmin: string | undefined | null;
  public isAPIUser: boolean | undefined | null;
  public currentSubscriptionName: string = '--';

  get isApiCallsPlan(): boolean {
    const planName = this.userObject?.subscription?.name || this.currentSubscriptionName || '';
    return String(planName).toLowerCase().includes('api calls per month');
  }

  get isBasicApiCallsPlan(): boolean {
    const planName = String(this.userObject?.subscription?.name || this.currentSubscriptionName || '').toLowerCase();
    return planName.includes('api calls') && /\b200\b/.test(planName);
  }

  get isFreePlan(): boolean {
    const planName = this.userObject?.subscription?.name || this.currentSubscriptionName || '';
    return String(planName).toLowerCase() === 'free';
  }

  get subscriptionPaymentText(): string {
    const cost = this.userObject?.subscription?.cost;
    const period = this.userObject?.subscription?.period;

    if (!cost && !period) return '--';

    const paymentText = `${cost || ''} ${period || ''}`.trim();
    return paymentText.toLowerCase() === '£0.00 yearly' ? 'Free' : paymentText;
  }

  showCanceledMessage: boolean = false;


  public text_UID_Admin: string | undefined | null;

  loaderSubs: boolean = false;


  ActualMonth: string;

  getMaskedPassword(): string {
    return this.pass ? '*'.repeat(this.pass.length) : '--';
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordVisibility2() {
    this.showPassword2 = !this.showPassword2;
  }

  togglePasswordVisibilityCurrent() {
    this.showPassword3 = !this.showPassword3;
  }

  passwordsMatch(): boolean {
    return this.pass === this.confirmPass;
  }

  displayedColumns: string[] = ['name', 'wordCount', 'sections', 'actions'];
  projects = new MatTableDataSource<Project>([

  ]);

  displayedColumns_Error: string[] = ['date', 'code', 'endpoint'];
  Error_Details = new MatTableDataSource<Error>([
  ]);

  displayedColumnsUsers: string[] = ['id','user', 'typeSubs', 'start_d', 'end_d', 'last_logged_on', 'organisation', 'actions'];
  users = new MatTableDataSource<Users>([
  ]);

  minHeight = this.getPrincipalApiDashHeight();
  minHeight2;
  counterPlan_Org;
  counterSubs;
  counterApiUsage;
  counterApiDash;



  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // -------------------------------------------------NG ON INIT-------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------

 inactivitySeconds = 0;
inactivityTimer: any;   // timeout de 60s
countInterval: any;     // intervalo de 1s
inactivityTimeLimit = 60; // en segundos

payment:any;


  ngOnInit(): void {
    localStorage.setItem("actual", "profile")
    this.currentSubscriptionName = localStorage.getItem('name_subs') || '--';

    // Limpia cualquier intervalo anterior
    
    const pantalla_actual = localStorage.getItem("actual");
    if (pantalla_actual === "profile") {
      this.clearAllTimers();
      this.startInactivityWatcher();
    }



    this.userObject = this.userService.getdata()
    console.log("Este usuario es del perfil")
    console.log(this.userObject);
    this.name = this.userObject.user.first_name;
    this.email = this.userObject.user.email;
    this.pass = this.datos_pagina.pass;
    this.text_UID = this.userObject.text_UID
    this.isAdmin = this.userObject.subscription.name;
    this.isAPIUser = this.userObject.subscription.beneficios.some(item => item._type === "APIUser");

    if (this.isAdmin === "Free") {
      this.userObject.subscription.name = "Free"
    }
    localStorage.setItem("Limit_words", this.userObject.subscription.beneficios[0].word_count)


    if (this.isAdmin === "Admin") {
      this.tabOrganisation = true;
    }
    else if (this.isAdmin?.startsWith('Organisation')) {
      this.tabOrganisation = true;
    }
    else {
      this.tabOrganisation = false;
    }

    const storedPayment = this.getStoredPayment();

    if (storedPayment) {
      // && this.payment.status !== "Never"
      this.payment = storedPayment; 
      // Meti esta linea de codigo aqui porque causaba conflicto con las fechas, pero por alguna razon estaba afuera, revisar si causa conflicto en otras cosas, por el momento con el Admin no causa problemas
      // Causo conflicto en el usuario no mostrando el metodo de pago (Ya que intentaba acceder a una propiedad que no existia)
    
      this.name_payment_test = this.payment.payment ?? '';
      const startDate = new Date(this.payment.start * 1000);
      const endDate = new Date(this.payment.end * 1000);

      console.log(startDate );

      this.payment_start = startDate;
      this.payment_end = endDate;

      this.payment_range_text = this.formatPaymentRange(startDate, endDate);

      this.payment_status = this.payment.status ?? '';
      this.payment_ok = this.payment.ok ?? null;

      this.showCanceledMessage = this.shouldShowCanceledSubscriptionMessage(startDate, endDate);
    }else{
      const usedSubscriptionPayment = this.applyPaymentFromSubscriptionFallback();

      if (!usedSubscriptionPayment && !this.isAPIUser){
        //Si no podemos acceder a esto suponemos porque la pago via Paypal (Y solo pintamos el nombre) para que aparezca la info y muestre el mensaje
        this.name_payment_test = "Paypal"
  
        this.payment_start = null;
        this.payment_end = null;
        this.payment_range_text = '';

      }
    }



    this.setOverlayPosition();

    window.addEventListener('resize', () => {
      this.setOverlayPosition();
      if (this.isAdmin === "Admin") {
        this.minHeight = this.getPrincipalApiDashHeight();
      }
    });

    if (this.isAdmin === "Admin") {
      this.updatePaginationProjects();
    }


    this.proyectoService.limitOfProjectsP$.subscribe(state => {
      if (state) {
        this.valueLimitProjects = true;
        setTimeout(() => {
          this.valueLimitProjects = false;
        }, 4000);
      }
    });


    const endDefault = new Date(); // Fecha actual completa
    const startDefault = new Date(endDefault);
    const actualDateHourly = new Date();
    startDefault.setDate(endDefault.getDate() - 10); // 10 días atrás, fecha completa
    this.dateForm.patchValue({ start: startDefault, end: endDefault });



    // Sincroniza inmediatamente
    this.dateRange = { start: startDefault, end: endDefault };
    this.startDate = startDefault;
    this.endDate = endDefault;

    this.updateDateText();

    const startFormatted = this.datePipe.transform(startDefault, 'MMM d', undefined, 'en-US');
    const endFormatted = this.datePipe.transform(endDefault, 'MMM d', undefined, 'en-US');
    const year = this.datePipe.transform(endDefault, 'yyyy', undefined, 'en-US');

    const startFormattedHourly = this.datePipe.transform(actualDateHourly, 'MMM d', undefined, 'en-US');

    this.DateText = `${startFormatted} - ${endFormatted}, ${year}`;
    this.DateText2 = `${startFormattedHourly}, ${year}`;


    this.ActualMonth = this.getCurrentBillingCycleText();





    if (this.isAdmin === "Admin") {

      //DESCOMENTAR PARA API USAGE 
      this.initApidash()
      this.initRangeApidash()
      this.onDateSelected(new Date());

      this.checkScroll();
      this.checkScroll2();
      this.checkScroll3();
    }
  }

  formatPaymentRange(start: Date, end: Date): string {
  const format = (date: Date) => {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  return `From ${format(start)} - Until ${format(end)}`;
}

  private getStoredPayment(): any | null {
    const paymentStorage = localStorage.getItem('payment');

    if (!paymentStorage || paymentStorage === 'undefined' || paymentStorage === 'null') {
      return null;
    }

    try {
      const payment = JSON.parse(paymentStorage);
      return payment && payment.start && payment.end ? payment : null;
    } catch (error) {
      return null;
    }
  }

  private applyPaymentFromSubscriptionFallback(): boolean {
    const stripePayment = this.getStripePaymentFromUserObject();

    if (stripePayment) {
      this.applyPaymentData(stripePayment);
      return true;
    }

    const subscription = this.userObject?.subscription;
    const startDate = this.parseSubscriptionPaymentDate(subscription?.start);
    const endDate = this.parseSubscriptionPaymentDate(subscription?.end);

    if (!startDate || !endDate) {
      return false;
    }

    this.applyPaymentData({
      payment: subscription?.payment ?? '',
      start: Math.floor(startDate.getTime() / 1000),
      end: Math.floor(endDate.getTime() / 1000),
      status: subscription?.status ?? '',
      ok: subscription?.ok ?? null
    });

    return true;
  }

  private getStripePaymentFromUserObject(): any | null {
    const stripeInfo = this.parseStripeInfo(this.userObject?.stripe_info);
    const stripeData = stripeInfo?.data;
    const firstStripeItem = Array.isArray(stripeData) && stripeData.length > 0 ? stripeData[0] : null;

    if (!firstStripeItem?.current_period_start || !firstStripeItem?.current_period_end) {
      return null;
    }

    return {
      payment: 'Stripe',
      start: this.normalizeUnixTimestamp(firstStripeItem.current_period_start),
      end: this.normalizeUnixTimestamp(firstStripeItem.current_period_end),
      status: this.userObject?.subscription?.status ?? '',
      ok: this.userObject?.subscription?.ok ?? null
    };
  }

  private parseStripeInfo(stripeInfo: any): any | null {
    if (!stripeInfo) return null;
    if (typeof stripeInfo !== 'string') return stripeInfo;

    try {
      return JSON.parse(stripeInfo);
    } catch (error) {
      return null;
    }
  }

  private normalizeUnixTimestamp(value: number | string): number {
    const timestamp = Number(value);
    return timestamp > 9999999999 ? Math.floor(timestamp / 1000) : timestamp;
  }

  private applyPaymentData(payment: any): void {
    this.payment = payment;
    const startDate = new Date(this.payment.start * 1000);
    const endDate = new Date(this.payment.end * 1000);

    localStorage.setItem('payment', JSON.stringify(this.payment));

    this.name_payment_test = this.payment.payment ?? '';
    this.payment_start = startDate;
    this.payment_end = endDate;
    this.payment_range_text = this.formatPaymentRange(startDate, endDate);
    this.payment_status = this.payment.status ?? '';
    this.payment_ok = this.payment.ok ?? null;
    this.showCanceledMessage = this.shouldShowCanceledSubscriptionMessage(startDate, endDate);
  }

  private shouldShowCanceledSubscriptionMessage(startDate: Date, endDate: Date): boolean {
    const isCanceled = this.payment_status === 'Canceled';
    const isSubscriptionFallbackPayment = this.payment?.payment === '';

    return (isCanceled || isSubscriptionFallbackPayment) && this.isTodayInRange(startDate, endDate);
  }

  private parseSubscriptionPaymentDate(value: string | null | undefined): Date | null {
    if (!value) return null;

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})[:T ](\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return null;

    const date = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5]),
      Number(match[6])
    );

    return Number.isNaN(date.getTime()) ? null : date;
  }

  private getCurrentBillingCycleText(): string {
    const cycleStart = this.getCurrentBillingCycleStartDate();
    const cycleEnd = this.getCurrentBillingCycleEndDate(cycleStart);

    const startText = this.datePipe.transform(cycleStart, 'MMM d', undefined, 'en-US');
    const endText = this.datePipe.transform(cycleEnd, 'MMM d', undefined, 'en-US');
    const yearText = this.datePipe.transform(cycleEnd, 'yyyy', undefined, 'en-US');

    return `${startText} - ${endText}, ${yearText}`;
  }

  private getCurrentBillingCycleStartDate(): Date {
    const today = new Date();

    if (!this.payment_start || Number.isNaN(this.payment_start.getTime())) {
      return new Date(today.getFullYear(), today.getMonth(), 1);
    }

    let cycleStart = this.getBillingCycleDate(today.getFullYear(), today.getMonth(), this.payment_start.getDate());

    if (today < cycleStart) {
      cycleStart = this.getBillingCycleDate(today.getFullYear(), today.getMonth() - 1, this.payment_start.getDate());
    }

    return cycleStart;
  }

  private getCurrentBillingCycleEndDate(cycleStart: Date): Date {
    if (!this.payment_start || Number.isNaN(this.payment_start.getTime())) {
      return new Date(cycleStart.getFullYear(), cycleStart.getMonth() + 1, 0);
    }

    const nextCycleStart = this.getBillingCycleDate(cycleStart.getFullYear(), cycleStart.getMonth() + 1, this.payment_start.getDate());
    const cycleEnd = new Date(nextCycleStart);
    cycleEnd.setDate(cycleEnd.getDate() - 1);
    return cycleEnd;
  }

  private getBillingCycleDate(year: number, month: number, billingDay: number): Date {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    return new Date(year, month, Math.min(billingDay, daysInMonth));
  }

  isTodayInRange(start: Date, end: Date): boolean {
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);

  return today >= start && today <= end;
}



  ngOnDestroy(): void {
    this.clearAllTimers();
 this.removeActivityListeners();
  if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
}
startInactivityWatcher() {
  // Listeners para detectar actividad
  window.addEventListener("mousemove", this.resetTimer);
  window.addEventListener("keydown", this.resetTimer);
  window.addEventListener("scroll", this.resetTimer);
  window.addEventListener("click", this.resetTimer);

  // Arranca el temporizador
  this.resetTimer();
}
resetTimer = () => {

  this.clearAllTimers();
  // Reinicia contadores
  this.inactivitySeconds = 0;


  // Empieza a contar cada segundo
  this.countInterval = setInterval(() => {
    this.inactivitySeconds++;

    if (this.inactivitySeconds >= this.inactivityTimeLimit) {
      clearInterval(this.countInterval);
    }
  }, 1000);

  // Timeout de 60s sin actividad
  this.inactivityTimer = setTimeout(() => {
    this.onInactivityDetected();
  }, this.inactivityTimeLimit * 1000);
};
onInactivityDetected() {
  const pantalla_actual = localStorage.getItem("actual");

  if (pantalla_actual === "profile") {
    this.counterPlan_Org = 0;
    this.counterSubs = 0;
    this.counterApiUsage = 0;
    this.counterApiDash = 0;
    console.log("60s sin actividad");
  }
}
removeActivityListeners() {
  window.removeEventListener("mousemove", this.resetTimer);
  window.removeEventListener("keydown", this.resetTimer);
  window.removeEventListener("scroll", this.resetTimer);
  window.removeEventListener("click", this.resetTimer);
}

clearAllTimers() {
  if (this.inactivityTimer) {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = null;
  }

  if (this.countInterval) {
    clearInterval(this.countInterval);
    this.countInterval = null;
  }

  this.inactivitySeconds = 0;
}



apiUpdatePage(){
  this.proyectoService.updatecallUpdateApiPage(true);
}



  formatDateToAPI(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // los meses empiezan en 0
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private getDateTimePartsInApiTimeZone(date: Date): Record<string, string> {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: this.apiTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);

    return parts.reduce((acc, part) => {
      if (part.type !== 'literal') acc[part.type] = part.value;
      return acc;
    }, {} as Record<string, string>);
  }

  private formatDateInApiTimeZone(date: Date): string {
    const parts = this.getDateTimePartsInApiTimeZone(date);
    return `${parts['year']}-${parts['month']}-${parts['day']}`;
  }

  private getHourInApiTimeZone(date: Date): number {
    return Number(this.getDateTimePartsInApiTimeZone(date)['hour']);
  }

  private formatDateTimeInApiTimeZone(date: Date): string {
    const parts = this.getDateTimePartsInApiTimeZone(date);
    const yy = String(parts['year']).slice(-2);

    return `${parts['day']}/${parts['month']}/${yy} ${parts['hour']}:${parts['minute']}:${parts['second']} (${this.apiTimeZoneLabel})`;
  }

  async cancelSubscription() {
      try {
    
        const dialogRef = this.dialog.open(ModalCancelSubscriptionComponent, {
          data: {
            name: this.name_payment_test,     
          },
          backdropClass: 'dialog-backdrop-dark', 
        });
    

       dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          console.log("Se canceló con éxito la subs");
          window.location.reload();
        } else if (result === false) {
          console.log("No se pudo cancelar la subs");
        }
      });
      } catch (error) {
        console.error('Error al cancelar la subs:', error);
      }
    }

  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // -------------------------------------------------PETICION API DASHBOARD-------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------



  async initApidash(data = undefined) {
    let token2 = localStorage.getItem("text-inspector-django-token")
    const billingStartDateAPI = this.formatDateToAPI(this.getCurrentBillingCycleStartDate());
    this.loaderActive = true;


    // Funcionaliad original
    if (!data) {
      try {
        let respuesta = await this.fachada.getAllApiDashboard(
          this.http,
          token2,
          billingStartDateAPI
        );

        // Asignar los valores del endpoint
        if (respuesta && respuesta.data) {
          this.apiCallsMadeT = respuesta.total ?? 0;
          this.unusedApiCalls = respuesta.restantes ?? 0;
          this.apiCallsMade = respuesta.uso ?? 0;
          this.totalDocuments = respuesta.documentos_totales ?? 0;
          this.dailyAverage = respuesta.promedio ?? 0;
          this.applyApiAllowanceFromPlan(data);
        }
        this.loaderActive = false;
      } catch (error) {
        console.log(error);
        this.loaderActive = false;
      }
    }
    else {
      try {
        let respuesta = await this.fachada.getAllApiDashboardUsage(
          this.http,
          token2, data.user_id, billingStartDateAPI
        );

        // Asignar los valores del endpoint
        if (respuesta && respuesta.data) {
          this.apiCallsMadeT = respuesta.total ?? 0;
          this.unusedApiCalls = respuesta.restantes ?? 0;
          this.apiCallsMade = respuesta.uso ?? 0;
          this.totalDocuments = respuesta.documentos_totales ?? 0;
          this.dailyAverage = respuesta.promedio ?? 0;
          this.applyApiAllowanceFromPlan(data);
        }
        this.loaderActive = false;
      } catch (error) {
        console.log(error);
        this.loaderActive = false;
      }
    }



  }

  private applyApiAllowanceFromPlan(data = undefined): void {
    const planLimit = this.getApiCallLimitFromPlan(data);

    if (planLimit === null) {
      return;
    }

    const callsMade = Number(this.apiCallsMade) || 0;
    this.apiCallsMadeT = planLimit;
    this.unusedApiCalls = Math.max(planLimit - callsMade, 0);
  }

  private getApiCallLimitFromPlan(data = undefined): number | null {
    const planCandidates = [
      data?.subscription_name,
      data?.subscription?.name,
      data?.plan_name,
      data?.plan,
      data?.user_info?.subscription?.name,
      data?.user_info?.plan_name,
      data?.user_info?.plan,
      this.currentSubscriptionName,
      localStorage.getItem('name_subs')
    ];

    for (const plan of planCandidates) {
      const limit = this.extractApiCallLimit(plan);
      if (limit !== null) {
        return limit;
      }
    }

    return null;
  }

  private extractApiCallLimit(planText: any): number | null {
    if (!planText) {
      return null;
    }

    const match = String(planText).match(/(\d[\d,]*)\s*API\s*Calls\s*per\s*month/i);
    if (!match) {
      return null;
    }

    return Number(match[1].replace(/,/g, ''));
  }


  /*-----------------------------------------------------------------------*/
  /*-----------------------------------------------------------------------*/
  /*-----------------------------------------------------------------------*/

  valido: boolean;
  valido2: boolean;

  async initRangeApidash(data = undefined) {
    let token2 = localStorage.getItem("text-inspector-django-token")
    this.loaderActive2 = true;
    const startDateAPI = this.formatDateToAPI(this.startDate);
    const endDateAPI = this.formatDateToAPI(this.endDate);
    if (!data) {
      try {
        let respuesta = await this.fachada.getRangeApiDashboard(
          this.http,
          token2,
          startDateAPI,
          endDateAPI
        );

        const eventos = Array.isArray(respuesta.data) ? respuesta.data : [];

        this.showChartContainer = false;
        setTimeout(() => {
          this.chartData.labels = this.generateLabels();
          this.chartData3.labels = this.generateLabels();
          const labels = this.generateLabels();
          if (eventos.length === 0) {
            this.chartData.datasets[0].data = [];
            this.chartData3.datasets[0].data = [];
            this.generateStatusData(eventos, labels, this.startDate, this.endDate);

            this.Error_Details.data = [];
            this.fillErrorTable(eventos);

            const validos = eventos.filter(e =>
              e.status !== undefined &&
              e.status !== 200 &&
              e.method !== undefined &&
              e.request_type !== undefined
            );
            if (validos.length > 0) {
              this.valido = true; // sí hay datos válidos → mostrar tabla
            } else {
              this.valido = false; // no hay datos válidos → mostrar "There is no data"
            }

            const validos2 = eventos.filter(e =>
              e.status !== undefined &&
              e.status !== 200
            );
            if (validos2.length > 0) {
              this.valido2 = true; // sí hay datos válidos → mostrar tabla
            } else {
              this.valido2 = false; // no hay datos válidos → mostrar "There is no data"
            }
            this.minHeight = this.getPrincipalApiDashHeight();
          } else {
            this.chartData.datasets[0].data = this.generateRangeData(eventos, this.startDate, this.endDate);
            // Llenar los datos de la gráfica (por método y fecha)
            this.generateStatusData(eventos, labels, this.startDate, this.endDate);
            // Llenar los datos de la tabla
            this.fillErrorTable(eventos);

            const validos = eventos.filter(e =>
              e.status !== undefined &&
              ((String(e.status).startsWith('5')) || (String(e.status).startsWith('4'))) &&
              e.method !== undefined &&
              e.request_type !== undefined
            );
            if (validos.length > 0) {
              this.valido = true; // hay datos válidos → mostrar tabla
            } else {
              this.valido = false; // no hay datos válidos → no mostrar
            }
            const validos2 = eventos.filter(e =>
              ((String(e.status).startsWith('4')) || (String(e.status).startsWith('5')))
            );
            if (validos2.length > 0) {
              this.valido2 = true; // sí hay datos válidos → mostrar tabla
            } else {
              this.valido2 = false; // no hay datos válidos → mostrar "There is no data"
            }
            this.minHeight = this.getPrincipalApiDashHeight();
          }


          this.showChartContainer = true;
          this.cdr.detectChanges();
          this.loaderActive2 = false;
        }, 0);

      } catch (error) {
        console.error(error);
        this.loaderActive2 = false;
      } finally {
        this.loaderActive2 = false;
      }
    }
    else {
      try {
        let respuesta = await this.fachada.getRangeApiDashboardUsage(
          this.http,
          token2,
          startDateAPI,
          endDateAPI, data.user_id
        );

        const eventos = Array.isArray(respuesta.data) ? respuesta.data : [];

        this.showChartContainer = false;
        setTimeout(() => {
          this.chartData.labels = this.generateLabels();
          this.chartData3.labels = this.generateLabels();
          const labels = this.generateLabels();
          if (eventos.length === 0) {
            this.chartData.datasets[0].data = [];
            this.chartData3.datasets[0].data = [];
            this.generateStatusData(eventos, labels, this.startDate, this.endDate);

            this.Error_Details.data = [];
            this.fillErrorTable(eventos);

            const validos = eventos.filter(e =>
              e.status !== undefined &&
              e.method !== undefined &&
              e.request_type !== undefined
            );
            if (validos.length > 0) {
              this.valido = true; // sí hay datos válidos → mostrar tabla
            } else {
              this.valido = false; // no hay datos válidos → mostrar "There is no data"
            }

            const validos2 = eventos.filter(e =>
              e.status === 404 || e.status === 500
            );
            if (validos2.length > 0) {
              this.valido2 = true; // sí hay datos válidos → mostrar tabla
            } else {
              this.valido2 = false; // no hay datos válidos → mostrar "There is no data"
            }
            if (this.more_info_api_usage) {
              this.minHeight2 = this.getPrincipalApiDashHeight2();
            }
          } else {
            this.chartData.datasets[0].data = this.generateRangeData(eventos, this.startDate, this.endDate);
            // Llenar los datos de la gráfica (por método y fecha)
            this.generateStatusData(eventos, labels, this.startDate, this.endDate);
            // Llenar los datos de la tabla
            this.fillErrorTable(eventos);


            const validos = eventos.filter(e =>
              e.status !== undefined &&
              ((String(e.status).startsWith('5')) || (String(e.status).startsWith('4'))) &&
              e.method !== undefined &&
              e.request_type !== undefined
            );
            if (validos.length > 0) {
              this.valido = true; // hay datos válidos → mostrar tabla
            } else {
              this.valido = false; // no hay datos válidos → no mostrar
            }
            const validos2 = eventos.filter(e =>
              ((String(e.status).startsWith('4')) || (String(e.status).startsWith('5')))
            );
            if (validos2.length > 0) {
              this.valido2 = true; // sí hay datos válidos → mostrar tabla
            } else {
              this.valido2 = false; // no hay datos válidos → mostrar "There is no data"
            }
            if (this.more_info_api_usage) {
              this.minHeight2 = this.getPrincipalApiDashHeight2();
            }
          }


          this.showChartContainer = true;
          this.cdr.detectChanges();
          this.loaderActive2 = false;
        }, 0);

      } catch (error) {
        console.error(error);
        this.loaderActive2 = false;
      } finally {
        this.loaderActive2 = false;
      }
    }


  }

  /*-----------------------------------------------------------------------*/
  /*-----------------------------------------------------------------------*/
  /*-----------------------------------------------------------------------*/

  async initOneDayApidash(date: Date, data = undefined) {
    this.loaderActive3 = true;
    let token2 = localStorage.getItem("text-inspector-django-token")
    if (!data) {
      try {
        const startDateAPI = this.formatDateToAPI(date);

        let respuesta: any = await this.fachada.getOneDayApiDashboard(
          this.http,
          token2,
          startDateAPI
        );



        let eventos = Array.isArray(respuesta.data) ? respuesta.data : [];

        if (eventos.length === 0) {
          this.chartData2.datasets[0].data = [];
        } else {
          this.chartData2.datasets[0].data = this.generateHourlyData(eventos, date);
        }


        
        this.showChartContainer2 = false;
        setTimeout(() => {
          this.showChartContainer2 = true;
          this.loaderActive3 = false;
        }, 0);

      } catch (error) {
        console.error("Error en initOneDayApidash:", error);
        this.loaderActive3 = false;
      }
    } else {
      try {
        const startDateAPI = this.formatDateToAPI(date);

        let respuesta: any = await this.fachada.getOneDayApiDashboardUsage(
          this.http,
          token2,
          startDateAPI, data.user_id
        );



        let eventos = Array.isArray(respuesta.data) ? respuesta.data : [];

        if (eventos.length === 0) {
          this.chartData2.datasets[0].data = [];
        } else {
          this.chartData2.datasets[0].data = this.generateHourlyData(eventos, date);
        }


        // Forzar render (tu código)
        this.showChartContainer2 = false;
        setTimeout(() => {
          this.showChartContainer2 = true;
          this.loaderActive3 = false;
        }, 0);

      } catch (error) {
        console.error("Error en initOneDayApidash:", error);
        this.loaderActive3 = false;
      }
    }

  }

  async refreshApiDashboard(data = undefined) {
    const dashboardData = data ?? (this.selectedTab === "api-usage" ? this.more_info_api_usage : undefined);
    const selectedDay = this.selectedDate || new Date();

    await Promise.all([
      this.initApidash(dashboardData),
      this.initRangeApidash(dashboardData),
      this.initOneDayApidash(selectedDay, dashboardData)
    ]);

    this.checkScroll();
    this.checkScroll2();
    this.checkScroll3();
  }

  updateDateText() {
    const startFormatted = this.datePipe.transform(this.startDate, 'MMM d', undefined, 'en-US');
    const endFormatted = this.datePipe.transform(this.endDate, 'MMM d', undefined, 'en-US');
    const year = this.datePipe.transform(this.endDate, 'yyyy', undefined, 'en-US');
    this.DateText = `${startFormatted} - ${endFormatted}, ${year}`;
  }

  showCalendars = false;


  // Method to open the date picker (called on button click)
  openDatePicker(picker1: any, picker2: any) {
    picker1.open();
    picker2.open();
  }


  // Método para alternar la expansión y cambiar el tamaño del cuadro de diálogo
  toggleExpand(): void {

    if (!this.many_users_org) {
      this.isExpanded = !this.isExpanded;
      this.isExpanded2 = !this.isExpanded2;
    } else {
      this.proyectoService.updatelimitProfileUsers(true);
    }

  }

  async selectTab(tab: string) {
    // limpiamos varialbes temporales de otras pestañas (agregado por api-usage)
    this.more_info_api_usage = undefined;
    //Seguimos con lógica normal
    this.selectedTab = tab;
    // Solo ejecutar el centrado si está en modo móvil
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        const sidebar = document.querySelector('.account-sidebar') as HTMLElement;
        const activeTab = document.querySelector('.account-sidebar li.active') as HTMLElement;

        if (sidebar && activeTab) {
          const sidebarRect = sidebar.getBoundingClientRect();
          const activeRect = activeTab.getBoundingClientRect();

          const scrollLeft =
            activeTab.offsetLeft - (sidebarRect.width / 2) + (activeRect.width / 2);

          sidebar.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      }, 100);

    }

    if (tab == "api-dashboard") {
      if (this.counterApiDash !== 1) {
        this.initApidash()
        this.initRangeApidash()
        this.initOneDayApidash(new Date())
        this.checkScroll();
        this.checkScroll2();
        this.checkScroll3();
        this.counterApiDash = 1;
      }

    }
    // Se agregan peticiones por tab en especifico para que no se haga lenta la carga de la pág.
    if (tab == "api-usage") {
      if (this.counterApiUsage !== 1) {
        this.apiUsage_loaderActive = true;
        console.log("Vamos a cargar la petición de obtener todas las peticiones");
        let temporal = await this.fachada.getApi_usage_data(this.http)
        this.usersApiDataOriginal = temporal.data;
        // Creamos la fuente de datos para la tabla
        this.api_usage_data = temporal.data;
        this.updatePaginationUsersApi();
        this.apiUsage_loaderActive = false;
        this.counterApiUsage = 1;
      }

    }
    if (tab == "admin") {
      if (this.counterSubs !== 1) {
        this.updatePaginationUsers();
        this.infoUsers();
        this.counterSubs = 1;
      }

    }
    if (tab == "subscription" || tab == "organisation") {
      if (this.counterPlan_Org !== 1 && !this.isAPIUser && this.isAdmin !== "Free") {
        this.loaderSubs = true;
        this.infoUsersOrganization();
        this.counterPlan_Org = 1;
      }

    }
  }

  selectedUserId: string | null = null;

  define_user_4more_info(row: any) {
    // Guardamos la fila seleccionada para resaltar en la tabla
    this.more_info_api_usage = row;

    // Obtenemos el user_id del usuario seleccionado
    const selectedUserId = row?.user_id || null;

    // Guardamos el ID en una variable del componente
    this.selectedUserId = selectedUserId;


    //DESCOMENTAR PARA API USAGE

    // Llamamos a la función de detalle pasando el usuario completo
    this.initApidash(this.more_info_api_usage);
    this.initRangeApidash(this.more_info_api_usage)
    this.initOneDayApidash(new Date(),this.more_info_api_usage)
    this.checkScroll();
    this.checkScroll2();
    this.checkScroll3();
  }


  selectButton(tab: boolean) {
    this.selectedButton = tab;
  }

  async cancelsubscription() {
    let respuesta = await this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Confirm To End Subscription",
        texto: "Are you sure you want to end your subscription?",
        texto_confirmar: "Yes, Unsubscribe",
        texto_cancelar: "Cancel"
      }
    }).afterClosed().toPromise();
    if (respuesta) {
      let response = await this.fachada.cancelarMisub(this.http)
      if (response.ok) {
        await this.dialog.open(ConfirmDialogComponent, {
          data: {
            title: "Subscription canceled",
            texto: "Your Subscription has been deactivated",
            texto_confirmar: "Ok",
            texto_cancelar: ""
          }
        })
      } else {
        await this.dialog.open(ConfirmDialogComponent, {
          data: {
            title: "Ops... Something went Wrong",
            texto: response.msg,
            texto_confirmar: "Ok",
            texto_cancelar: ""
          }
        })
      }
    }
  }

  checkToUpgrade() {
    const subsName = this.userObject.subscription.name;

    if (subsName === 'Free') {
      window.open(
        this.subscriptionRedirectUrl,
        '_self'
      );
      return;
    }

    // DESCOMENTAR CODIGO PARA API FLOW
    if (subsName.includes('API Calls')) {
      this.apiUpdatePage();
      return;
    }


    this.dialog.open(ModalCancelSubscriptionComponent, {
      data: {
        mode: 'upgrade-warning',
      },
      backdropClass: 'dialog-backdrop-dark',
    });
  }


  goToUpgrade() {
    window.open(
      this.subscriptionRedirectUrl,
      '_self' 
    );
  }




  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // -------------------------------------------------PETICION USUARIOS-------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------

  currentPageUsers = 1;
  itemsPerPage = 10;
  itemsPerPage2 = 10;
  paginatedUsers = new MatTableDataSource<Users>();
  pagesUsers: number[] = [];
  maxPagesToShow = 5;
  totalPages = 0;
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  rawUsers: any[] = [];

  async infoUsers() {
    this.loaderActive_subscribers = true;
    let token = "52babdfa69a0741ba564474fbad773c34a4ccdea";
    let token3 = "69091b5050c0d04991763f55fc1af42c0140d9f6";
    let token2 = localStorage.getItem("text-inspector-django-token")
    try {
      let response = await this.fachada.getInfoUsers(this.http, token2);

      this.rawUsers = response.usuarios ?? [];

      const usersData = response.usuarios.map((user: any) => {
        // Procesar start_date
        let startDateFormatted = '-';
        if (user.start_date && user.start_date !== 'null' && user.end_date !== 'undefined') {
          const [datePart] = user.start_date.split('<br /><i>'); // solo tomamos la primera parte (la fecha)
          startDateFormatted = datePart.trim(); // sin hora
        }

        // Procesar end_date
        let endDateFormatted = '-';
        if (user.end_date && user.end_date !== 'null' && user.end_date !== 'undefined') {
          const [datePart, timePart] = user.end_date.split('<br /><i>');
          const cleanTime = timePart ? timePart.replace('</i>', '').trim() : '';
          endDateFormatted = `${datePart.trim()}\n${cleanTime}`;
        }
        let paypal_info = "";
        if (user.paypal_email) {
          paypal_info =  `\nPaypal email: ${user.paypal_email}`
        }
        let logged_on_info = "";
        if (user.last_login_date) {
          const [datePart, timePart] = user.last_login_date.split('<br /><i>');
          const cleanTime = timePart ? timePart.replace('</i>', '').trim() : '';
          logged_on_info = cleanTime ? `${datePart.trim()}\n${cleanTime}` : datePart.trim();
        }
        

        return {
          id: user.id,
          user: user
            ? `${user.username || ''}\n${user.email || ''} ${paypal_info}`
            : '-',

          // typeSubs: user
          //   ? `${user.name}${user.payment_status && user.payment_status !== 'Not Found'
          //     ? `\nPayment status: ${user.payment_status}`
          //     : ''
          //   }`
          //   : '-',

          typeSubs: user
            ? `${user.name}` : '-',

          start_d: startDateFormatted,

          end_d: endDateFormatted,

          last_logged_on: logged_on_info,

          organisation: user.organisation?.leader
            ? `${user.organisation.leader.name}\n${user.organisation.leader.email || '-'}`
            : '-',
        };
      });




      this.usersDataOriginal = usersData; // guardamos la copia original
      this.users.data = usersData;
      this.updatePaginationUsers();
      this.loaderActive_subscribers = false;
    } catch (error) {
      if (error.status === 403) {
        console.error("Acceso denegado.Checar Token");
      } else {
        console.error("Profile info error:", error);
      }
      this.loaderActive_subscribers = false;
    }
  }

  planMap: any = {
    "Organisation": 4,
    "Free": 1,
    "Organisation Plus EVP": 5,
    "Standard Plus EVP": 3,
    "Standard": 2,
    "Admin": 6,
    "Organisation Plus EVP - Yearly": 18,
    "Standard Plus EVP - Yearly": 16
  };

  editUser(row: Users) {
    try {

      // Si el objeto ya incluye id/email/extra_permissions, los usamos directamente
      let id = (row as any).id ?? null;
      let username = (row as any).username ?? null;
      let email = (row as any).email ?? null;
      let extra_permissions = (row as any).extra_permissions ?? null;
      let planName = (row as any).typeSubs ?? null;
      let max_users = (row as any).id ?? null;
      // Buscar en rawUsers si falta info
      if (this.rawUsers && this.rawUsers.length) {
        const possibleUsername = (row.user || '').split('\n')[0]?.trim();
        const possibleEmail = (row.user || '').split('\n')[1]?.trim();

        const found = this.rawUsers.find((u: any) =>
          (u.id && (u.id === (row as any).id))
        );

        if (found) {
          console.log('Usuario encontrado:', found);
          id = found.id ?? id;
          username = found.username ?? username;
          email = found.email ?? email;
          extra_permissions = found.extra_permissions ?? extra_permissions;
          planName = found.name ?? planName;
          max_users = found.organisation?.max ?? null
        } else {
          console.warn('No se encontró usuario:', {
            possibleUsername,
            possibleEmail
          });
        }
      }

      // Convertir nombre del plan a número
      const planNumber = this.planMap[planName] ?? null;
      let extraPermsArr: string[] = [];

      if (extra_permissions) {
        if (typeof extra_permissions === 'string') {
          extraPermsArr = extra_permissions
            .split(',')
            .map((p: string) => p.trim());
        }
        else if (Array.isArray(extra_permissions)) {
          extraPermsArr = extra_permissions;
        }
        else if (typeof extra_permissions === 'object') {
          extraPermsArr = Object.entries(extra_permissions)
            .filter(([key, value]) => value === "true" || value === true)
            .map(([key]) => key);
        }
      }
      if ((planNumber== "4" || planNumber== "5" || planNumber== "18") && max_users == null){
        // si es de organización y no tiene max le asignamos 10 por defecto
        max_users = 10;
      }

      const modalData = {
        id,
        username,
        email,
        plan: planNumber,
        extraPermissions: extraPermsArr,
        max_users: max_users
      };

      console.log('Abriendo EditSubsAdminComponent con data:', modalData);

      const dialogRef = this.dialog.open(EditSubsAdminComponent, {
        data: modalData,
        backdropClass: 'dialog-backdrop-dark'
      });

      dialogRef.afterClosed().subscribe(async (result: any) => {
        console.log('EditSubsAdminComponent cerrado. Resultado:', result);
        if (result) {
          const index = this.users.data.findIndex(u => u.id === result.id);
          if (index !== -1) {
            this.users.data[index].typeSubs = Object.keys(this.planMap).find(k => this.planMap[k] === result.plan) ?? this.users.data[index].typeSubs;
            this.users.data[index].extra_permissions = result.extra_permissions ?? this.users.data[index].extra_permissions;
            this.users = new MatTableDataSource<Users>(this.users.data);
            await this.infoUsers();
            this.applyUserSearch();
          } else {
            console.warn('No se encontró fila para actualizar con id:', result.id);
          }
        }
      });

    } catch (error) {
      console.error("Error abriendo modal:", error);
    }
  }




  searchTerm: string = '';
  usersDataOriginal: any[] = [];

  applyUserSearch() {
    const term = this.searchTerm.trim().toLowerCase();

    if (!term) {
      // Si el campo está vacío, restauramos todos los datos
      this.users.data = this.usersDataOriginal;
    } else {
      // Filtrar por coincidencias en 'user' o 'organisation'
      const filtered = this.usersDataOriginal.filter(user =>
        user.user?.toLowerCase().includes(term) ||
        user.organisation?.toLowerCase().includes(term)
      );

      this.users.data = filtered;
    }

    // Reiniciar paginación con los nuevos datos
    this.currentPageProjects = 1;
    this.sortColumn = '';
    this.updatePaginationUsers();
  }

  seeAllUsers() {
    this.searchTerm = '';                  // Limpiar input
    this.users.data = this.usersDataOriginal;  // Restaurar todos los registros
    this.currentPageUsers = 1;             // Ir a la primera página
    this.sortColumn = '';
    this.updatePaginationUsers();          // Actualizar paginación
  }


  updatePaginationUsers() {
    const totalItems = this.users.data.length;
    this.totalPages = Math.ceil(totalItems / this.itemsPerPage);

    if (this.currentPageUsers < 1) {
      this.currentPageUsers = 1;
    } else if (this.currentPageUsers > this.totalPages && this.totalPages > 0) {
      this.currentPageUsers = 1;
    }

    const start = (this.currentPageUsers - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedUsers.data = this.users.data.slice(start, end);


    const max = this.maxPagesToShow;
    let startPage = this.currentPageUsers - Math.floor(max / 2);
    let endPage = this.currentPageUsers + Math.floor(max / 2);

    // Ajustar si se pasa al inicio
    if (startPage < 1) {
      startPage = 1;
      endPage = Math.min(max, this.totalPages);
    }

    // Ajustar si se pasa al final
    if (endPage > this.totalPages) {
      endPage = this.totalPages;
      startPage = Math.max(1, this.totalPages - max + 1);
    }

    // Generar listado final
    this.pagesUsers = Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  }





  goToPageUsers(page: number) {
    this.currentPageUsers = page;
    this.updatePaginationUsers();
  }

  prevPageUsers() {
    if (this.currentPageUsers > 1) {
      this.currentPageUsers--;
      this.updatePaginationUsers();
    }
  }

  nextPageUsers() {
    if (this.currentPageUsers < Math.ceil(this.users.data.length / this.itemsPerPage)) {
      this.currentPageUsers++;
      this.updatePaginationUsers();
    }
  }

  sortUsers(column: string) {
    // Alternar asc/desc si vuelves a dar click en la misma columna
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    // Copia de datos actuales según búsqueda
    let data = [...this.users.data];

    data.sort((a: any, b: any) => {
      let valA = '';
      let valB = '';

      switch (column) {
        case 'user':
          // Solo ordenar por username
          valA = a.user.split('\n')[0].toLowerCase();
          valB = b.user.split('\n')[0].toLowerCase();
          break;

        case 'typeSubs':
          valA = a.typeSubs.toLowerCase();
          valB = b.typeSubs.toLowerCase();
          break;

        case 'start_d':
          valA = a.start_d.toLowerCase();
          valB = b.start_d.toLowerCase();
          break;

        case 'end_d':
          valA = a.end_d.toLowerCase();
          valB = b.end_d.toLowerCase();
          break;

        case 'last_logged_on':
          valA = (a.last_logged_on || '').toLowerCase();
          valB = (b.last_logged_on || '').toLowerCase();
          break;

        case 'organisation':
          // ordenar por leader.email (está en segunda línea)
          valA = a.organisation.split('\n')[1]?.toLowerCase() || '';
          valB = b.organisation.split('\n')[1]?.toLowerCase() || '';
          break;
      }

      if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    // Asignar orden
    this.users.data = data;

    // Reiniciar a página 1
    this.currentPageUsers = 1;

    // Actualizar paginación
    this.updatePaginationUsers();
  }


 exportToExcel(): void {
  this.loaderActive_export = true; 
  // Tomar solo los datos filtrados actualmente
  const dataToExport = this.users.data;

  if (!dataToExport || dataToExport.length === 0) {
    console.warn("No hay datos para exportar");
    return;
  }

  // Convertir datos para exportar:
  const formattedData = dataToExport.map((user: any) => ({
    Username: user.user,
    Subscription: user.typeSubs,
    "Start date": user.start_d,
    "End date": user.end_d,
    "Last login date": user.last_logged_on || '-'
  }));

  // Convertir a Excel
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);

  ws['!cols'] = [
    { width: 50 }, // user
    { width: 30 }, // typeSubs
    { width: 18 }, // start_d
    { width: 18 }, // end_d
    { width: 18 }  // last_login
  ];

  const wb: XLSX.WorkBook = {
    Sheets: { 'Usuarios': ws },
    SheetNames: ['Usuarios']
  };

  const buffer: any = XLSX.write(wb, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob: Blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  // Generar fecha actual en formato YYYYMMDD
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const formattedDate = `${yyyy}${mm}${dd}`;

  saveAs(blob, `${formattedDate}-Subscribers.xlsx`);
  this.loaderActive_export = false; 
}




  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // -------------------------------------------------PETICION USUARIOS ORGANIZATION-------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------------------------------------------------------------

  many_users_org: boolean;
  userIdMap: Map<string, string> = new Map();
  tabOrganisation: boolean;
  organisationInfo: any = null;


  async infoUsersOrganization() {
    this.loaderActive_organization = true;
    let token = "52babdfa69a0741ba564474fbad773c34a4ccdea";
    let token3 = "69091b5050c0d04991763f55fc1af42c0140d9f6";
    let token2 = localStorage.getItem("text-inspector-django-token")
    try {
      let response = await this.fachada.getInfoUsersOrganization(this.http, token2);



      this.tabOrganisation = true;
      this.isRolLeader = response.isLeader === true;

      // Guardamos toda la información en la variable general
      this.organisationInfo = response.organisation || null;

      const usersData: any[] = [];
      this.userIdMap.clear(); // Limpiamos el mapa

      // Siempre agregamos al líder, aunque no haya usuarios
      const leader = response.organisation.leader;
      if (leader) {
        usersData.push({
          name: leader.name || '-',
          wordCount: leader.email || '-',
          sections: 'Leader'
        });
        const key = `${leader.name}-${leader.email}`;
        this.userIdMap.set(key, leader.id);
      }

      // Agregamos a los miembros si existen
      const users = Array.isArray(response.organisation.users) ? response.organisation.users : [];
      users.forEach((user: any) => {
        const key = `${user.name}-${user.email}`;
        usersData.push({
          name: user.name || '-',
          wordCount: user.email || '-',
          sections: 'Member'
        });
        this.userIdMap.set(key, user.id);
      });
      let usuarios_permitidos = parseInt(localStorage.getItem("OrganisationSize")) || 10
      // Controlamos si hay muchos usuarios
      this.users_organization_limit = usuarios_permitidos;
      this.many_users_org = users.length >= usuarios_permitidos;

      // Cargamos los datos en la tabla
      this.projects.data = usersData;
      this.updatePaginationProjects();
      this.loaderActive_organization = false;
      this.loaderSubs = false;




    } catch (error) {
      if (error.status === 403) {
        console.error("Acceso denegado.Checar Token");
      } else {
        console.error("Profile info error:", error);
      }
      this.loaderActive_organization = false;
      this.loaderSubs = false;
    }
  }

  newMemberEmail: string = ''; // Variable ligada al input

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.newMemberEmail = inputElement.value;
  }

  // Función para validar email
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  alert_message: string;
  adding_member: boolean;

  async addMember() {
    const email = this.newMemberEmail.trim();

    // Validación básica
    if (!email) {
      this.proyectoService.sendMessageProfileUsers('Please enter an email.');
      return;
    }

    if (!this.isValidEmail(email)) {
      this.proyectoService.sendMessageProfileUsers('Please enter a valid email.');
      return;
    }

    try {
      this.adding_member = true;
      await this.fachada.addMemerOrganization(this.http, email);

      // Limpiar input
      this.newMemberEmail = '';
      this.toggleExpand(); // cerrar panel si quieres
      this.infoUsersOrganization();

      // Opcional: refrescar la tabla de miembros
      this.updatePaginationProjects();
      this.adding_member = false;

    } catch (error) {
      const errorMsg =
        error?.error?.msg || // si viene dentro de error.error.msg
        error?.msg ||        // si viene como error.msg
        'There was a problem.'; // mensaje por defecto

      this.proyectoService.sendMessageProfileUsers('There was a problem. ' + errorMsg);
      console.error('Error adding member:', error);
      this.adding_member = false;
    }
  }

  async deleteMember(row: any) {
    // Generamos la clave para buscar el ID
    const key = `${row.name}-${row.wordCount}`;
    const userId = this.userIdMap.get(key);

    if (!userId) {
      console.error('No se encontró el ID del usuario para borrar');
      return;
    }

    const dialogRef = this.dialog.open(MemberRemoveComponent, {
      data: { name: row.name },
      backdropClass: 'dialog-backdrop-dark'
    });

    const confirmed = await dialogRef.afterClosed().toPromise();
    if (confirmed) {
      try {
        this.loaderActive_organization = true;
        await this.fachada.deleteMemerOrganization(this.http, userId);

        // Actualizamos la tabla eliminando la fila
        this.projects.data = this.projects.data.filter(u => u !== row);
        this.updatePaginationProjects();

        // Eliminamos del mapa interno
        this.userIdMap.delete(key);

        //  Recalculamos cuantos miembros quedan
        const remainingMembers = this.projects.data.filter(u => u.sections === 'Member').length;

        //  Actualizamos many_users_org según la cantidad
        this.many_users_org = remainingMembers >= 10;

        this.loaderActive_organization = false;

      } catch (error) {
        console.error("Error al eliminar el miembro:", error);
      }
    }
  }





  getMethodColor(method: string): string {
    switch (method.toUpperCase()) {
      case 'GET': return '#4CAF50';      // Verde
      case 'POST': return '#2196F3';     // Azul
      case 'PUT': return '#FFC107';      // Amarillo
      case 'DELETE': return '#F44336';   // Rojo
      case 'OPTIONS': return '#9E9E9E';  // Gris
      default: return '#607D8B';         // Azul grisáceo
    }
  }



  showPicker: boolean = false;

  @ViewChild('startPicker') startPicker!: ElementRef<HTMLInputElement>;
  @ViewChild('endPicker') endPicker!: ElementRef<HTMLInputElement>;

  apiCallsMadeT
  apiCallsMade;
  unusedApiCalls;
  get usagePercentage() {
    return Math.round((this.apiCallsMade / (this.apiCallsMade + this.unusedApiCalls)) * 100);
  }

  totalDocuments;
  dailyAverage;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [{
      data: [],
      backgroundColor: '#8A268C',
      label: 'Calls',
      barPercentage: 0.4,
      categoryPercentage: 1
    }]
  };

  showDataLabels = false;

  chartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: 'white',
        font: (context) => {
          const labelCount = context.chart.data.labels?.length || 0;
          return {
            size: labelCount > 20 ? 10 : 12 // Cambia el tamaño según el número de días
          };
        },
        formatter: (value) => {
          return value > 0 ? value : null; // Solo muestra valores mayores a 0
        },
        display: (context) => this.showDataLabels
      }
    },
    scales: {
      x: { ticks: { maxRotation: 90, minRotation: 90, color: '#2A3654' }, grid: { display: false } },
      y: { stacked: true, beginAtZero: true, ticks: { stepSize: 2, color: '#2A3654' } }
    }
  };

  onScroll(): void {
    this.checkScroll();
  }

  checkScroll() {
    if (!this.scrollContainer) return;

    const scrollLeft = this.scrollContainer.nativeElement.scrollLeft;

    const shouldShow = scrollLeft > 10; // mostrar datalabels si scroll > 10px
    if (shouldShow !== this.showDataLabels) {
      this.showDataLabels = shouldShow;

      const canvas = this.scrollContainer.nativeElement.querySelector('canvas');
      const chartInstance = Chart.getChart(canvas!);
      chartInstance?.update();
    }
  }


  chartData2: ChartData<'bar'> = {
    labels: [],
    datasets: [{
      data: [],
      backgroundColor: '#8A268C',
      label: 'Calls',
      barPercentage: 1,      // aumenta el ancho de cada barra
      categoryPercentage: 1  // reduce el espacio entre barras
    }]
  };

  showDataLabels2 = false;
  @ViewChild('scrollContainer2') scrollContainer2!: ElementRef;

  chartOptions2: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: 'white',
        formatter: (value) => {
          return value > 0 ? value : null; // Solo muestra valores mayores a 0
        },
        display: (context) => this.showDataLabels2
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 90,
          color: "#2A3654",

        },
        grid: {
          display: false
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          stepSize: 2,
          color: '#2A3654'
        }
      }
    }
  };

  onScroll2(): void {
    this.checkScroll2();
  }

  checkScroll2() {
    if (!this.scrollContainer2) return;

    const scrollLeft = this.scrollContainer2.nativeElement.scrollLeft;

    const shouldShow = scrollLeft > 10; // mostrar datalabels si scroll > 10px
    if (shouldShow !== this.showDataLabels2) {
      this.showDataLabels2 = shouldShow;

      const canvas = this.scrollContainer2.nativeElement.querySelector('canvas');
      const chartInstance = Chart.getChart(canvas!);
      chartInstance?.update();
    }
  }






  chartData3: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        label: '2XX',
        data: [],
        backgroundColor: '#FFBC72',
        barPercentage: 0.4,
        categoryPercentage: 1
      },
      {
        label: '4XX',
        data: [],
        backgroundColor: '#8097FF',
        barPercentage: 0.4,
        categoryPercentage: 1
      },
      {
        label: '5XX',
        data: [],
        backgroundColor: '#FF6673',
        barPercentage: 0.4,
        categoryPercentage: 1
      }
    ]
  };

  showDataLabels3 = false;
  @ViewChild('scrollContainer3') scrollContainer3!: ElementRef;

  chartOptions3: ChartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: 'white',
        font: (context) => {
          const labelCount = context.chart.data.labels?.length || 0;
          return {
            size: labelCount > 20 ? 10 : 12 // Cambia el tamaño según el número de días
          };
        },
        // formatter: (value, context) => {
        // const datasets = context.chart.data.datasets;
        // const index = context.dataIndex;

        // // Solo mostrar label para el último dataset de cada barra
        // if (context.datasetIndex !== datasets.length - 1) {
        //   return null;
        // }

        // // Sumar todos los valores de esa barra
        // const total = datasets.reduce(
        //   (sum, ds) => sum + (ds.data[index] as number || 0),
        //   0
        // );

        // return total > 0 ? total : null;
        // },
        formatter: (value) => {
          // Mostrar solo si el valor es mayor a 0
          return value > 0 ? value : null;
        },
        display: (context) => this.showDataLabels3
      }
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          maxRotation: 90,
          minRotation: 90,
          color: '#2A3654'
        },
        grid: { display: false }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          stepSize: 2,
          color: '#2A3654'
        }
      }
    }
  };

  onScroll3(): void {
    this.checkScroll3();
  }

  checkScroll3() {
    if (!this.scrollContainer3) return;

    const scrollLeft = this.scrollContainer3.nativeElement.scrollLeft;

    const shouldShow = scrollLeft > 10; // mostrar datalabels si scroll > 10px
    if (shouldShow !== this.showDataLabels3) {
      this.showDataLabels3 = shouldShow;

      const canvas = this.scrollContainer3.nativeElement.querySelector('canvas');
      const chartInstance = Chart.getChart(canvas!);
      chartInstance?.update();
    }
  }



  generateLabels(): string[] {
    if (!this.startDate || !this.endDate) return [];
    const labels: string[] = [];
    let start = new Date(this.startDate);
    const end = new Date(this.endDate);
    while (start <= end) {
      // Formato corto SOLO para labels de gráfica
      labels.push(start.toLocaleDateString('en-US', { month: 'short', day: '2-digit' }));
      start.setDate(start.getDate() + 1); // Avanza día usando fecha completa
    }
    return labels;
  }

  generateLabels2(): string[] {
    const labels: string[] = [];
    for (let h = 0; h < 24; h++) {
      labels.push(`${h.toString().padStart(2, '0')}:00`);
    }
    return labels;
  }

  generateRangeData(events: any[], startDate: Date, endDate: Date): number[] {
    const labels = this.generateLabels();
    const data: number[] = new Array(labels.length).fill(0);

    if (!events || events.length === 0) return data;

    const countMap: { [key: string]: number } = {};
    events.forEach(event => {
      if (!event.date) return;
      countMap[event.date] = (countMap[event.date] || 0) + 1;
    });

    let currentDate = new Date(startDate);
    for (let i = 0; i < labels.length; i++) {
      const dateKey = this.formatDateToAPI(currentDate);
      data[i] = countMap[dateKey] || 0;
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return data;
  }

  generateRangeData2(events: any[], startDate: Date, endDate: Date): number[] {
    const labels = this.generateLabels();
    const data: number[] = new Array(labels.length).fill(0);

    if (!events || events.length === 0) return data;

    const countMap: { [key: string]: number } = {};
    events.forEach(event => {
      if (!event.date) return;
      countMap[event.date] = (countMap[event.date] || 0) + 1;
    });

    let currentDate = new Date(startDate);
    for (let i = 0; i < labels.length; i++) {
      const dateKey = this.formatDateToAPI(currentDate);
      data[i] = countMap[dateKey] || 0;
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return data;
  }

  total404;
  total500;

  /** Generar datos agrupados por STATUS y día */
  generateStatusData(events: any[], labels: string[], startDate: Date, endDate: Date) {

    // ⚠️ Ignorar los eventos con status 200
    events = events.filter(e => !(String(e.status).startsWith('2')));

    this.chartData3 = {
      labels: this.generateLabels(),
      datasets: [{ data: [] }]
    };

    const countMap: Record<string, Record<string, number>> = {};

    events.forEach(event => {
      if (!event.date || !event.status) return;

      const dateParts = event.date.split('-'); // ["2025","10","06"]
      const dateLocal = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1, // meses base 0
        Number(dateParts[2])
      );

      // formato YYYY-MM-DD (según tu formatDateToAPI)
      const date = this.formatDateToAPI(dateLocal);

      const status = String(event.status);
      let group = '';
      if (status.startsWith('4')) group = '4xx';
      else if (status.startsWith('5')) group = '5xx';
      else return;

      if (!countMap[date]) countMap[date] = {};
      countMap[date][group] = (countMap[date][group] || 0) + 1;
    });


    const statusColors: Record<string, string> = {
      '4xx': '#8097FF',
      '5xx': '#FF6673'
    };

    const statusGroups = Object.keys(statusColors);

    const datasets = statusGroups.map(group => ({
      label: group,
      data: new Array(labels.length).fill(0),
      backgroundColor: statusColors[group],
      barPercentage: 0.4,
      categoryPercentage: 1,
      stack: 'statusStack'
    }));

    // Rellenar datos por día
    let currentDate = new Date(startDate);
    for (let i = 0; i < labels.length; i++) {
      const dateKey = this.formatDateToAPI(currentDate);
      if (countMap[dateKey]) {
        for (const group of statusGroups) {
          const dataset = datasets.find(d => d.label === group);
          if (dataset) dataset.data[i] = countMap[dateKey][group] || 0;
        }
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    const totals: Record<string, number> = { '4xx': 0, '5xx': 0 };
    Object.values(countMap).forEach(dayCounts => {
      for (const group of statusGroups) {
        totals[group] += dayCounts[group] || 0;
      }
    });

    this.chartData3.datasets = datasets;
    this.total404 = totals['4xx'];
    this.total500 = totals['5xx'];

  }



  private pad(n: number) {
    return n < 10 ? '0' + n : String(n);
  }

  /** Rellenar la tabla con datos de eventos */
  fillErrorTable(events: any[]) {

    const formattedRows: Error[] = (events || [])
      .filter(ev =>
        ev &&
        ev.method &&
        ev.request_type &&
        (ev.status !== undefined && ev.status !== null) &&
        !String(ev.status).startsWith('2') // Excluir 200
        &&
        !String(ev.status).startsWith('302') // Excluir 302
      )
      .map(ev => {
        // Construye Date desde timestamp Unix y lo muestra en zona horaria UK fija.
        let dt: Date;
        if (ev.timestamp) {
          dt = new Date(Number(ev.timestamp) * 1000);
        } else if (ev.date) {
          dt = new Date(ev.date + 'T00:00:00');
        } else {
          dt = new Date();
        }

        const dateFormatted = this.formatDateTimeInApiTimeZone(dt);

        return {
          date: dateFormatted,
          code: String(ev.status),
          endpoint: ev.request_type,
          method: String(ev.method)
        } as Error;
      });


    this.Error_Details = new MatTableDataSource<Error>(formattedRows);

    this.paginatedProjects = new MatTableDataSource<Error>(formattedRows);

    try {
      if ((this as any).paginator) this.Error_Details.paginator = (this as any).paginator;
      if ((this as any).sort) this.Error_Details.sort = (this as any).sort;
    } catch (e) {
      console.warn('fillErrorTable - no paginator/sort asignados o no existen aún');
    }

    //  Forzar detección de cambios para que la tabla se actualice
    this.cdr.detectChanges();
  }



  generateHourlyData(events: any[], date: Date): number[] {
    const hours = 24;
    const data: number[] = new Array(hours).fill(0);
    const targetDate = this.formatDateToAPI(date); // "YYYY-MM-DD"

    if (!Array.isArray(events)) {
      console.error("❌ No es un array:", events);
      return data;
    }

    // Contar eventos por hora
    events.forEach(event => {
      if (!event.timestamp) return;

      const eventDateObj = new Date(event.timestamp * 1000);
      const eventDate = this.formatDateInApiTimeZone(eventDateObj);
      const eventHour = this.getHourInApiTimeZone(eventDateObj);

      if (eventDate === targetDate) {
        data[eventHour] += 1;
      }
    });

    // Intercalar dos etiquetas "espacio" entre cada hora
    const spacedData: number[] = [];
    const spacedLabels: string[] = [];

    for (let i = 0; i < hours; i++) {
      spacedLabels.push(`${i.toString().padStart(2, "0")}:00`);
      spacedData.push(data[i]);
    }

    this.chartData2.labels = spacedLabels;
    return spacedData;
  }


  dateRange: { start: Date | null; end: Date | null } = { start: null, end: null };
  readonly errorColors = ['#FFBC72', '#8097FF', '#FF6673'];
  readonly errorLabels = ['2XX', '4XX', '5XX'];
  selectedDate: Date = new Date();


  onDateSelected(date: Date) {
    this.loaderActive3 = true;
    this.chartData2 = {
      labels: this.generateLabels2(),
      datasets: [{
        data: [],
        backgroundColor: '#8A268C',
        label: 'Calls',
        barPercentage: 0.4,
        categoryPercentage: 1
      }]
    };
    this.selectedDate = date;
    this.dateForm.patchValue({ date });

    const dayMonth = this.datePipe.transform(date, 'MMM d', undefined, 'en-US');
    const year = this.datePipe.transform(date, 'yyyy', undefined, 'en-US');
    this.DateText2 = `${dayMonth}, ${year}`;


    // Llamar API con la fecha seleccionada

    if (this.selectedTab == "api-dashboard") {
      setTimeout(() => {
        this.initOneDayApidash(date);
      }, 0);
    }
    if (this.selectedTab == "api-usage") {
      setTimeout(() => {
        this.initOneDayApidash(date, this.more_info_api_usage)
      }, 0);
    }


    this.closeCalendar2();
  }


  getPrincipalApiDashHeight(): string {
    if (window.innerWidth > 1000) return 'auto';

    const projectsCount = this.Error_Details.data.length;

    if (projectsCount === 0) return '330dvh';
    if (projectsCount < 4) return '340dvh';
    if (projectsCount >= 4 && projectsCount <= 6) return '350dvh';
    if (projectsCount > 6 && projectsCount <= 10) return '370dvh';
    if (projectsCount > 10) return '380dvh';

    return 'auto';
  }


  getPrincipalApiDashHeight2(): string {
    if (window.innerWidth > 1000) return 'auto';

    const projectsCount = this.Error_Details.data.length;

    if (projectsCount === 0) return '400dvh';
    if (projectsCount < 4) return '410dvh';
    if (projectsCount >= 4 && projectsCount <= 6) return '420dvh';
    if (projectsCount > 6 && projectsCount <= 10) return '440dvh';
    if (projectsCount > 10) return '450dvh';

    return 'auto';
  }



  openStartPicker() {
    this.startPicker.nativeElement.showPicker();
  }

  openEndPicker() {
    this.endPicker.nativeElement.showPicker();
  }

  toggleCalendar() {
    if (this.calendarOpen) {
      this.picker.close();
    } else {
      this.picker.open();
    }
    this.calendarOpen = !this.calendarOpen;

  }

  toggleCalendar2() {
    this.calendarOpen2 = !this.calendarOpen2;
  }

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @ViewChild(CdkOverlayOrigin) trigger!: CdkOverlayOrigin;
  @ViewChild(CdkOverlayOrigin) trigger2!: CdkOverlayOrigin;
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;

  calendarOpen = false;
  calendarOpen2 = false;

  overlayPositions: any[] = [];

  setOverlayPosition() {
    this.overlayPositions = [
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        offsetY: 10,
        offsetX: window.innerWidth < 1000 ? 40 : 0
      }
    ];
  }

  closeCalendar() {
    this.picker.close();
    this.calendarOpen = false;
  }

  onPickerClosed() {
    this.calendarOpen = false;

    const { start, end } = this.dateForm.value;

    if (start && end) {
      // Si las fechas son iguales a las anteriores, no se hace nada
      if (
        this.startDate &&
        this.endDate &&
        start.getTime() === this.startDate.getTime() &&
        end.getTime() === this.endDate.getTime()
      ) {
        // Las fechas no cambiaron, salimos
        return;
      }

      if (start <= end) {
        const startFormatted = this.datePipe.transform(start, 'MMM d', undefined, 'en-US');
        const endFormatted = this.datePipe.transform(end, 'MMM d', undefined, 'en-US');
        const year = this.datePipe.transform(end, 'yyyy', undefined, 'en-US');

        this.DateText = `${startFormatted} - ${endFormatted}, ${year}`;
        this.dateRange = { start, end };
        this.startDate = start;
        this.endDate = end;

        if (this.selectedTab == "api-dashboard") {
          this.initRangeApidash();
        }
        if (this.selectedTab == "api-usage") {
          this.initRangeApidash(this.more_info_api_usage);
        }
      }
    }
  }


  closeCalendar2() {
    this.calendarOpen2 = false;
  }

  onStartDateChange(date: Date) {
    this.startDate = date;
    this.dateForm.patchValue({ start: date });
    // this.dateForm.patchValue({ start: date, end: this.endDate });
  }

  onEndDateChange(date: Date) {
    this.endDate = date;
    this.dateForm.patchValue({ end: date });
    // this.dateForm.patchValue({ start: this.startDate, end: date });
  }

  updatePaginationProjects() {
    const start = (this.currentPageProjects - 1) * this.itemsPerPage2;
    const end = start + this.itemsPerPage2;
    this.paginatedProjects.data = this.Error_Details.data.slice(start, end);
    const totalPages = Math.ceil(this.Error_Details.data.length / this.itemsPerPage2);
    const startPage = Math.max(1, this.currentPageProjects - Math.floor(this.maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + this.maxPagesToShow - 1);

    if (totalPages === 0) {
      this.pagesProjects = [1];
    } else {
      this.pagesProjects = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  }


  goToPageProjects(page: number) {
    this.currentPageProjects = page;
    this.updatePaginationProjects();
  }

  prevPageProjects() {
    if (this.currentPageProjects > 1) {
      this.currentPageProjects--;
      this.updatePaginationProjects();
    }
  }

  nextPageProjects() {
    if (this.currentPageProjects < Math.ceil(this.Error_Details.data.length / this.itemsPerPage2)) {
      this.currentPageProjects++;
      this.updatePaginationProjects();
    }
  }


  currentPageUsersApi = 1;
  searchTermApi: string = '';
  usersApiDataOriginal: any[] = [];

  applyUserSearchApi() {
    const term = this.searchTermApi.trim().toLowerCase();

    if (!term) {
      // Restaurar todos los datos si el campo está vacío
      this.api_usage_data = this.usersApiDataOriginal;
    } else {
      // Filtrar por coincidencias en nombre o email
      const filtered = this.usersApiDataOriginal.filter((user: any) =>
        user.user_info?.name?.toLowerCase().includes(term) ||
        user.user_info?.email?.toLowerCase().includes(term)
      );

      this.api_usage_data = filtered;
    }

    // Reiniciar paginación con los nuevos datos
    this.currentPageUsersApi = 1;
    this.updatePaginationUsersApi();
  }

  paginatedApiUsers: any[] = [];
  pagesUsersApi: number[] = [];
  itemsPerPageApi = 10;
  seeAllUsersApi() {
    this.searchTermApi = ''; // Limpiar campo de búsqueda
    this.api_usage_data = this.usersApiDataOriginal; // Restaurar todos los registros
    this.currentPageUsersApi = 1; // Ir a la primera página
    this.updatePaginationUsersApi(); // Actualizar paginación
  }

  updatePaginationUsersApi() {
    const totalItems = this.api_usage_data.length;
    const totalPages = Math.ceil(totalItems / this.itemsPerPageApi);

    // Asegurar página válida
    if (this.currentPageUsersApi < 1) {
      this.currentPageUsersApi = 1;
    } else if (this.currentPageUsersApi > totalPages && totalPages > 0) {
      this.currentPageUsersApi = 1;
    }

    // Calcular rango de elementos visibles
    const start = (this.currentPageUsersApi - 1) * this.itemsPerPageApi;
    const end = start + this.itemsPerPageApi;
    this.paginatedApiUsers = this.api_usage_data.slice(start, end); // 👈 lista visible en la tabla

    // Calcular las páginas visibles
    const startPage = Math.max(1, this.currentPageUsersApi - Math.floor(this.maxPagesToShow / 2));
    let endPage = startPage + this.maxPagesToShow - 1;
    if (endPage > totalPages) endPage = totalPages;

    this.pagesUsersApi =
      totalPages === 0
        ? [1]
        : Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }



  goToPageUsersApi(page: number) {
    this.currentPageUsersApi = page;
    this.updatePaginationUsersApi();
  }

  prevPageUsersApi() {
    if (this.currentPageUsersApi > 1) {
      this.currentPageUsersApi--;
      this.updatePaginationUsersApi();
    }
  }

  nextPageUsersApi() {
    if (this.currentPageUsersApi < Math.ceil(this.api_usage_data.length / this.itemsPerPageApi)) {
      this.currentPageUsersApi++;
      this.updatePaginationUsersApi();
    }
  }


}
